import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

/**
 *
 * languageModule for PciNeedHelpModal
 *
 * @version 1.0.0
 */

const formattedMessage = {
  topBarTitle: <PortalMessage id='t.app.pciNeedHelpModal.topBarTitle' defaultMessage='Ti richiamiamo noi' />,
  primaryButtonLabel: <PortalMessage id='t.app.pciNeedHelpModal.primaryButtonLabel' defaultMessage='Avanti' />,
  cardTitle: (
    <PortalMessage id='t.app.pciNeedHelpModal.cardTitle' defaultMessage='Hai ancora bisogno del nostro supporto?' />
  ),
  cardSubtitle: (
    <PortalMessage
      id='t.app.pciNeedHelpModal.cardSubtitle'
      defaultMessage='Scegli la fascia oraria più comoda per te e verrai ricontattato dal nostro servizio di assistenza dedicato.'
    />
  ),
  selectLabel: <PortalMessage id='t.app.pciNeedHelpModal.selectLabel' defaultMessage='Fascia oraria' />,
  selectPlaceholder: (
    <PortalMessage id='t.app.pciNeedHelpModal.selectPlaceholder' defaultMessage='Seleziona fascia oraria' />
  ),
  privacyTitle: <PortalMessage id='t.app.pciNeedHelpModal.privacyTitle' defaultMessage='Consenso privacy' />,
  privacyText: (
    <PortalMessage
      id='t.app.pciNeedHelpModal.privacyText'
      defaultMessage='I dati personali raccolti saranno trattati in formato elettronico solo per dare esecuzione alla richiesta di contatto.'
    />
  ),
  privacyInfo: (
    <PortalMessage
      id='t.app.pciNeedHelpModal.privacyInfo'
      defaultMessage='Per ogni informazione sul trattamento dei dati e sui diritti dell’interessato si prega di consultare l’infomativa sul trattamento dei dati personali disponibile sulla nostra app Nexi Business o sul nostro sito www.nexi.it, nella sezione trasparenza.'
    />
  ),
  checkboxLabel: <PortalMessage id='t.app.pciNeedHelpModal.checkboxLabel' defaultMessage='Acconsento' />,
  requestSlotPM: <PortalMessage id='t.app.pciNeedHelpModal.requestSlotPM' defaultMessage='14:00 - 18:00' />,
  requestSlotAM: <PortalMessage id='t.app.pciNeedHelpModal.requestSlotAM' defaultMessage='09:00 - 13:00' />,
  callbackInfo: (dynamicParam) => (
    <PortalMessage
      values={{ dynamicParam }}
      id='t.app.pciNeedHelpModal.callbackInfo'
      defaultMessage='Verrai ricontattato al numero <b> {dynamicParam} </b> nei prossimi giorni nella fascia oraria selezionata.'
    />
  ),
  emptyErrorLabel: <PortalMessage id='t.app.error.requiredField' defaultMessage='Il campo è obbligatorio' />
}

export default formattedMessage
